// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__S0ouB","col":"CardReaderDesc_col__BucbX","label":"CardReaderDesc_label__1Nahm"};